var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 141,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.3183 117.537C95.7629 117.537 111.45 100.471 116.449 83.7494L123 85.6457C117.311 104.953 99.383 124.433 72.3183 124.433C40.7715 124.433 19.3956 97.0232 19.3956 71.51C19.3956 45.9967 40.5991 18.5872 72.3183 18.5872C90.2465 18.5872 104.555 27.8961 113.174 37.8945L112.829 16.5186L119.725 16.3462L120.242 50.9959L85.5921 50.4788L85.7645 43.5833L109.209 43.9281C101.969 34.964 88.8674 25.4827 72.3183 25.4827C44.7364 25.4827 26.291 49.2721 26.291 71.51C26.291 93.7479 44.7364 117.537 72.3183 117.537Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.c45872c25144b18d6e53d95abde7ef25.svg";
export { ForwardRef as ReactComponent };